import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { animeLibrary } from '@/mocks/animeData';

export default function ClassicsSection() {
  const classics = animeLibrary.filter((item) => item.isClassic);
  const [openId, setOpenId] = useState<string>(classics[0]?.id ?? '');

  return (
    <section id="classics" className="w-full py-16 md:py-24">
      <div className="px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Classics"
            title="完结神作推荐"
            description="篇幅完整、结局收束较好的四部完结作品。点开每一部，可以展开一段更长的说明，讲清楚它适合怎样的观看节奏。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-start">
          {classics.map((item, index) => {
            const isOpen = openId === item.id;
            return (
              <Reveal key={item.id} delay={index * 60}>
                <article
                  className={`rounded-lg border overflow-hidden transition-colors ${
                    isOpen
                      ? 'bg-background-100 border-primary-300'
                      : 'bg-background-100 border-background-200/70 hover:border-primary-300'
                  }`}
                >
                  <div className="flex gap-4 p-4">
                    <div className="flex-shrink-0 w-20 md:w-24 h-28 md:h-32 rounded-md overflow-hidden bg-background-200">
                      <img
                        src={item.poster}
                        alt={`${item.title} 完结作品封面`}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading text-lg font-bold text-foreground-950">
                        {item.title}
                      </h3>
                      <div className="mt-1.5 flex flex-wrap items-center gap-2 text-xs">
                        <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                          {item.genre}
                        </span>
                        <span className="px-2 py-0.5 rounded-full bg-background-200 text-foreground-700">
                          {item.episodes}
                        </span>
                        <span className="flex items-center gap-1 text-foreground-600">
                          <i className="ri-star-fill text-accent-500"></i>
                          {item.score}
                        </span>
                      </div>
                      <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                        {item.summary}
                      </p>
                    </div>
                  </div>

                  <div className="px-4 pb-4">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? '' : item.id)}
                      aria-expanded={isOpen}
                      className="inline-flex items-center gap-1.5 text-xs md:text-sm text-primary-600 hover:text-primary-700 cursor-pointer"
                    >
                      {isOpen ? '收起补充说明' : '展开补充说明'}
                      <i className={isOpen ? 'ri-arrow-up-s-line text-base' : 'ri-arrow-down-s-line text-base'}></i>
                    </button>
                    <div
                      className={`overflow-hidden transition-all duration-500 ${
                        isOpen ? 'max-h-96 mt-3 opacity-100' : 'max-h-0 opacity-0'
                      }`}
                    >
                      <p className="text-xs md:text-sm text-foreground-700 leading-relaxed bg-background-50 rounded-md p-4 border border-background-200/70">
                        {item.classicNote}
                      </p>
                    </div>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}